import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';

import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { Store } from '@ngrx/store';
import { EpcotConfigService } from 'packages/sports/web/app/src/common/epcot-config.service';

import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../../base/services/betslip-messages-provider.service';
import { IBetslipRootState } from '../../../../../base/store/state';
import { BetslipType } from '../../../../../core/betslip-type';
import { ISucceededSlipResult } from '../../../../betplacement/models';
import { BetslipResultActions } from '../../../actions';
import LinearResultBaseComponent from './linear-result-base.component';
import { DigitalResultSummaryService } from './linear-result-summary.service';

@Component({
    selector: 'bs-digital-linear-result-single',
    templateUrl: './linear-result-single.component.html',
    styleUrls: ['base-linear-result-model.component.scss', './linear-result-single.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DigitalResultSummaryService],
    standalone: false,
})
export class LinearResultSingleComponent extends LinearResultBaseComponent {
    @Input() succeededSlips: ISucceededSlipResult[];

    betslipType = BetslipType.Single;

    readonly isEpcotEnabled: boolean;
    readonly singleBet: string;
    readonly multiSingleBets: string;

    constructor(
        public resultSummaryService: DigitalResultSummaryService,
        @Inject(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: ILinearBetslipMessagesProviderService,
        public store: Store<IBetslipRootState>,
        epcotConfigService: EpcotConfigService,
    ) {
        super(store);

        const messages = messagesProvider.getMessages();
        this.singleBet = messages.linear.SingleBet;
        this.multiSingleBets = messages.linear.SingleBets;
        this.isEpcotEnabled = epcotConfigService.isEnabled();
    }

    get title(): string {
        if (this.succeededSlips.length === 1 && !this.isEpcotEnabled) {
            return this.singleBet;
        }

        return interpolateDoubleBracesString(this.multiSingleBets, { count: this.succeededSlips.length });
    }

    get betType(): string {
        return BetslipType.Single;
    }

    onKeepPlacedChanged(value: boolean): void {
        this.store.dispatch(BetslipResultActions.keepPlacedBetsInLinearSingle({ keepPlacedBetsInLinearSingle: value }));
    }
}
